// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const SetupFooterRoot = styled.footer`
  color: var(--mb-color-text-medium);
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px dashed var(--mb-color-border);
  border-radius: 0.5rem;
  text-align: center;
`;
